export default __webpack_public_path__ + "static/media/lavenderbg.05c3541a.jpg";